let last = 0;

/**
 * Wall-clock milliseconds, forced to strictly increase within a running tab.
 * Sync is last-write-wins on this value, so two writes to the same record must
 * never share a timestamp, and a clock that steps backwards must not make a
 * newer edit look older.
 */
export function nowMs(): number {
  const t = Date.now();
  last = t > last ? t : last + 1;
  return last;
}

/** Test seam. */
export function resetClock(): void {
  last = 0;
}
